/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type DiscoveryFeed_viewer$ref = any;
export type DiscoverContainer_viewer$ref = any;
export type DiscoverContainer_viewer = {
    readonly " $fragmentRefs": DiscoveryFeed_viewer$ref;
    readonly " $refType": DiscoverContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "DiscoverContainer_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "DiscoveryFeed_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'c307d0e1b23aed04772b3ba6b0f84c68';
export default node;
